import { isNil } from 'lodash';
import * as validationMessages from 'common/constants/messages/validations';
import {
  MULTIPLE_DISCOUNT_COLUMN_LEGEND,
  SPECIFIED_LABEL,
  WEIGHTING,
} from 'pages/Valuations/approaches/guidelinePublicCompanies/constants';
import { TransactionCompsValidationsParams } from 'pages/ValuationsAllocation/approaches/TransactionComps/types';
import { handleWeightingProbability } from 'pages/ValuationsAllocation/util';
import { GPC_APPROACH_CELL_ALIAS, LTM_MULTIPLE_COLUMNS_ALIAS } from './constants';

const validations = (params: TransactionCompsValidationsParams) => {
  const { cell, addFeedback, removeFeedback, removeFeedbackFromCell, tableData, parsedColumns } = params;
  const { isDisabled, gpcOptions } = tableData;
  const { columnLegend, rowNumber: rN, alias, columnId, value: cellValue } = cell;
  const columnIdString = columnId as string;
  const rowNumber = rN as number;

  if (LTM_MULTIPLE_COLUMNS_ALIAS.includes(columnIdString)) {
    if (isNil(cellValue)) {
      addFeedback(validationMessages.IS_REQUIRED_ERROR);
    } else {
      removeFeedback(validationMessages.IS_REQUIRED_ERROR);
    }
  }
  if (GPC_APPROACH_CELL_ALIAS.includes(alias) && MULTIPLE_DISCOUNT_COLUMN_LEGEND.includes(columnIdString)) {
    const nextKeyIndex = 1;
    const mdCellKey = `${columnLegend}${rowNumber + nextKeyIndex}`;
    const multipleDiscountCell = parsedColumns[mdCellKey];
    multipleDiscountCell.readOnly
      = gpcOptions.find(option => option.id === cellValue)?.name !== SPECIFIED_LABEL || isDisabled;
  }
  if (alias === WEIGHTING) {
    handleWeightingProbability({
      parsedColumns,
      addFeedback,
      removeFeedback,
      weightingAliasToSearch: WEIGHTING,
      removeFeedbackFromCell,
      shouldMultiplyBy100: false,
    });
  }
};

export default validations;
